import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { alpha, Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { HOME_LAYOUT_HEIGHT } from "../../app/common";

const imageSrc = `${process.env.PUBLIC_URL}/assets/messaging-maintenance.webp`;

const MessagingMaintenance = () => {
  const { t } = useTranslation("messaging");

  return (
    <Box
      data-testid="messaging-maintenance"
      sx={{
        maxWidth: "1300px",
        height: HOME_LAYOUT_HEIGHT,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "#fff",
        borderRadius: "8px",
      }}
    >
      <Box sx={{ flex: "0 0 12%" }} />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
          width: "100%",
          maxWidth: 640,
        }}
      >
        <Box
          component="img"
          src={imageSrc}
          alt=""
          sx={{ width: "100%", maxWidth: 420, height: "auto" }}
        />
        <Typography
          variant="header"
          sx={{ fontWeight: 700, textAlign: "center", fontSize: 28 }}
        >
          {t("maintenanceTopic")}
        </Typography>
        <Typography sx={{ textAlign: "center", fontSize: 18 }}>
          {t("maintenanceMessage")}
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 2,
            width: "100%",
            px: 2.5,
            py: 2.5,
            borderRadius: "12px",
            backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.08),
          }}
        >
          <InfoOutlinedIcon sx={{ color: "primary.main", fontSize: 28 }} />
          <Typography sx={{ textAlign: "center", fontSize: 18 }}>
            {t("maintenanceInfo")}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default MessagingMaintenance;
